module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.deniedAccessMessage) { ;
__p += '\n<div class="pz-alert alert alert-danger clearfix" role="alert">\n    <div class="triangle-icon"><i class="far fa-exclamation-triangle"></i></div>\n    <div class="alert-message">' +
((__t = ( data.deniedAccessMessage )) == null ? '' : __t) +
'</div>\n</div>\n';
 } ;
__p += '\n<div class="wrapper-body"></div>';
return __p
}